// Every list endpoint pages its results: `page` (1-based) and `page_size`
// (default 20, max 100), answered with { page, page_size, total, results }
// (docs/real-estate/be/10-api-reference.md §0.4). Dropdowns and other
// "pick any one" lists need the whole set, not just the first page — this
// walks the pages at the maximum size until `total` is reached.
export const MAX_PAGE_SIZE = 100;

export async function listAllPages(listFn, query = {}) {
  const results = [];
  let page = 1;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // Each page depends on the previous one's total, so they run in order.
    // eslint-disable-next-line no-await-in-loop
    const { data } = await listFn({
      ...query,
      page,
      page_size: MAX_PAGE_SIZE,
    });
    results.push(...data.results);
    if (!data.results.length || results.length >= data.total) {
      return results;
    }
    page += 1;
  }
}
